import { Text } from '@cad-arc';

export function SectionTitle({ title }: { title: string }) {
    return (
        <Text as="b" fontSize="large" color="tertiary">
            {title}
        </Text>
    );
}
